<template>
  <div class="approved-page">
	<Header></Header> <!-- 头部 -->
	<div class="content">
		<van-tabs @click="onApply" class="detail-lists" v-model="joa_activeTabName">
		  <van-tab v-for="item_tabs in joa_tabs" :name="item_tabs">
				<div slot="title">{{item_tabs}}</div>
				<van-list
				  v-model="joa_loading"
				  :finished="joa_finished"
				  finished-text=""
				  @load="onLoad"
				>
					<van-cell size="large" class="lists" v-for="(item,index) in joa_list">
					  <template slot="title">
						<a style="max-width: 78%;" v-if="item_tabs == 'EHR' && item.businessName.indexOf('外出') !== -1" :href="WEB_URL+'ehrdetailok?page=approved&types=wc&number='+item.applyNo+source"><span class="custom-title">{{item.applyNo}}</span></a>
						<a style="max-width: 78%;" v-else-if="item_tabs == 'EHR' && item.businessName.indexOf('请假') !== -1" :href="WEB_URL+'ehrdetailok?page=approved&types=qj&number='+item.applyNo+source"><span class="custom-title">{{item.applyNo}}</span></a>
						<a style="max-width: 78%;" v-else-if="item_tabs == 'EHR' && item.businessName.indexOf('补卡') !== -1" :href="WEB_URL+'ehrdetailok?page=approved&types=bk&number='+item.applyNo+source"><span class="custom-title">{{item.applyNo}}</span></a>
						<a style="max-width: 78%;" v-else :href="item.url"><span class="custom-title">{{item.applyNo}}</span></a>		
						
						<div class="right category_title">
							<span v-if="item.businessName.replace('审批', '')=='招待费'">招待费申请</span>
							<span v-else-if="item.businessName.replace('审批', '')=='差旅'">差旅申请</span>
							<span v-else>{{item.businessName.replace('审批', '')}}</span>
							<p class="date" style="margin-top:3px !important;">{{Common.formatDate(item.createDatetime)}}</p>
						</div>
					  </template>
					  <div slot="label">
						<span class="left c999">申请人:{{item.applyUserName}}</span> 
					  </div>
					</van-cell>
				</van-list>
		  </van-tab>
		</van-tabs>
		<NoDatas></NoDatas> <!-- 没有数据-->
		<Footer></Footer> <!-- 尾部 -->
	</div>
  </div>
</template>
<script type="text/javascript">
//console.log(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION')))
import axios from 'axios';
export default {
  created() {
  	var $rus=this.$router.history;
  	if($rus["current"].fullPath.indexOf('sys=fssc') !== -1){
  		this.joa_activeTabName="FSSC";
  		this.joa_systemId="FSSC";this.joa_page=0;this.getData("FSSC"); //获取数据
  	}else if($rus["current"].fullPath.indexOf('sys=ehr') !== -1){
  		this.joa_activeTabName="EHR";
  		this.joa_systemId="EHR";this.joa_page=0;this.getData("EHR"); //获取数据
  	}else{
  		//this.joa_activeTabName="OA";
  		//this.joa_systemId="OA";this.joa_page=0;this.getData("OA"); //获取数据	
		this.joa_activeTabName="FSSC";
		this.joa_systemId="FSSC";this.joa_page=0;this.getData("FSSC"); //获取数据
  	}
  },
  data() {
    return {
	  WEB_URL:this.CoreNew.WEB_URL,
	  joa_activeTabName:"FSSC",
	  //joa_tabs: ["OA","FSSC","EHR"],
	  joa_tabs: ["FSSC","EHR"],
	  joa_list: [],
	  joa_total:0,
	  joa_page:0,
	  joa_loading: false,
	  joa_finished: false,
	  joa_systemId:"FSSC",
		source:'',
	};
  },
    filters: {
    },
	mounted(){
		if(this.CoreNew.WEB_URL_SOURCE){
			this.source='&source='+this.CoreNew.WEB_URL_SOURCE
		}
	},
    methods: {
	    onApply: function (name, title) {
			this.joa_list=[];$(".no-datas").removeClass("show");
			if(name=="FSSC"){
				this.joa_systemId="FSSC";this.joa_page=0;this.getData("FSSC"); //获取数据
			}else if(name=="EHR"){
				this.joa_systemId="EHR";this.joa_page=0;this.getData("EHR"); //获取数据
			}else{
				//this.joa_systemId="OA";this.joa_page=0;this.getData("OA");
				 this.joa_systemId="FSSC";this.joa_page=0;this.getData("FSSC"); //获取数据
			}
	    },
	    getData: function (sid) {
		  this.joa_page++;this.joa_loading = true;
		  axios.get(this.CoreNew.OA_API_IP+"joa-business/mobile/approved", { 
		  	params: {systemId:sid,pageSize:this.CoreNew.PAGESIZE,currentPage:this.joa_page } ,
			headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
		  }).then(function (response) {
			if(response.data.flag==true){
				if(response.data.data["total"]==0){
					this.joa_list=[];
					this.joa_loading = false;this.joa_finished = true;
					$(".no-datas").addClass("show");
				}else{
					var $rs=response.data;
					if(typeof($rs.data["records"])=="string" &&　(sid==this.joa_systemId)){
						$(".no-datas").removeClass("show");
						this.joa_total=$rs.data["total"];
						var $list=JSON.parse($rs.data["records"]);
						this.joa_list=this.joa_list.concat($list);
						// 数据全部加载完成
						this.joa_loading = false;
						//alert(this.joa_list.length+"--"+this.joa_total)
						if (this.joa_list.length !=0 && (this.joa_list.length >= this.joa_total)) {
						  this.joa_finished = true;
						}else{
							this.getData(sid); //获取数据
						}
					}
				}
			}
		  }.bind(this)).catch(function (error) { 
		  		//alert("请求--我的审批--失败"+error);
		  		this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--我的审批--失败"+error);//记录错误
				console.log("请求--我的审批--失败"+error);  
		  });
		},
		Color: function () {
			this.r = Math.floor(Math.random()*255);
		    this.g = Math.floor(Math.random()*255);
		    this.b = Math.floor(Math.random()*255);
		    //this.joa_color = 'rgba('+ this.r +','+ this.g +','+ this.b +',0.8)';
		}
    }
};
</script>